import { render, staticRenderFns } from "./RemovalRequests.vue?vue&type=template&id=278eb0de&scoped=true&"
import script from "./RemovalRequests.vue?vue&type=script&lang=js&"
export * from "./RemovalRequests.vue?vue&type=script&lang=js&"
import style0 from "./RemovalRequests.vue?vue&type=style&index=0&id=278eb0de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278eb0de",
  null
  
)

export default component.exports